import { SearchInput } from "@marketplace/shared/ui";
import { getRouteApi } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const route = getRouteApi("/disbursement/claim-orders/");

export const ClaimOrderFilter = () => {
  const { q } = route.useSearch();
  const navigate = route.useNavigate();
  const [search, setSearch] = useState(q ?? "");
  const { t } = useTranslation("order", { keyPrefix: "claimOrderPage" });

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate({
        search: (prev) => ({
          ...prev,
          q: search,
          page: 1
        })
      });
    }, 300);

    return () => clearTimeout(timeout);
  }, [search, navigate]);

  return (
    <div className="mb-6">
      <SearchInput
        className="lg:w-[634px]"
        placeholder={t("searchPlaceholder")}
        value={search}
        onChange={setSearch}
      />
    </div>
  );
};
